export default {
  timeFormat(date) {
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? "0" + m : m;
    var d = date.getDate();
    d = d < 10 ? "0" + d : d;
    var h = date.getHours();
    h = h < 10 ? "0" + h : h;
    var minute = date.getMinutes();
    minute = minute < 10 ? "0" + minute : minute;
    var second = date.getSeconds();
    second = second < 10 ? "0" + second : second;
    return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
  },
  getDayOfWeek(date) {
    const day = date.getDay()
    switch (day) {
      case 0:
        return '星期日';
      case 1:
        return '星期一';
      case 2:
        return '星期二';
      case 3:
        return '星期三';
      case 4:
        return '星期四';
      case 5:
        return '星期五';
      case 6:
        return '星期六';
    }
  },

  //根据异常状态返回异常内容
  getAbnormalContentFromStatus(faultType, usbPort) {
    switch (faultType) {
      case 1:
          return '电机异常'
      case 2:
        return '制动异常';
      case 3:
        return '轿箱异常';
      case 4:
        return '左门异常';
      case 5:
        return '右门异常';
      case 6:
        return '门电机异常';
      case 7:
        return '门锁异常';
      default:
        return '未知异常';
    }
  },
  
}



// WEBPACK FOOTER //
// ./src/utils/common.js